export default __webpack_public_path__ + "static/media/instagram.dd868854.jpeg";